var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.element === 'input')?_c('input',{attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required}}):_c('select',{attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required}})])
}
var staticRenderFns = []

export { render, staticRenderFns }